import { useAuth0 } from '@auth0/auth0-react'
import Loading from '../component/Loading'
import ConstList from '../utils/ConstList'
import { Button } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login'
import LogoutIcon from '@mui/icons-material/Logout'
function LoginButton() {
  const { isAuthenticated, loginWithRedirect, logout, isLoading } = useAuth0()
  // console.log('ログイン状態：' + isAuthenticated)
  // console.log('ローディング：' + isLoading)

  const options = {
    redirect_uri: window.location.origin,
    audience: 'https://m-and-t.jp.auth0.com/api/v2/',
    connection: ConstList.DATABASE_NAME,
    //audience: 'https://quickstarts/api',
  }

  if (isAuthenticated) {
    //ログイン情報があった場合
    return (
      <Button
        onClick={() => {
          //logout({ returnTo: 'https://system.syowa.com/kosu' })
          logout({ returnTo: window.location.origin + ConstList.SYS_TOPDOMAIN })
        }}
        variant="outlined"
        endIcon={<LogoutIcon />}
      >
        ログアウト
      </Button>
    )
  } else {
    //ログイン情報が無かった場合
    return isLoading ? ( //ローディングがTRUEだった場合
      <Loading />
    ) : (
      //ローディングがFALSEだった場合
// ログイン情報が無かった場合（isLoading === false のとき）
      <Button
       onClick={() => loginWithRedirect(options)}
       variant="contained"
       endIcon={<LoginIcon sx={{ color: 'inherit' }} />}  // ← アイコンはテキスト色を継承
         sx={{
            bgcolor: 'primary.main',
            color: '#fff',
        '&:hover': { bgcolor: 'primary.dark' },
      }}
      >
       ログイン
      </Button>

      // <button onClick={() => loginWithRedirect(options)}>ログイン</button>
    )
  }
}

export default LoginButton
